export const QueryKeys = {
  bitcoinPrice: 'bitcoin/price',
  historyPrice: 'bitcoin/history-price',
  blockHeight: 'blockchain/block-height',
  guardRecords: 'oracle/guards-records',
  contract: 'ducat/contract',
  contractProfile: 'ducat/contractProfile',
  oracleQuote: 'oracle/quote',

  accountVaultList: 'account/vault-list', // v3
  vaultHistory: 'vault/history', // v3
  walletBalance: 'wallet/balance', // v3
  walletAssets: 'wallet/assets', // v3
  walletCoinUtxos: 'wallet/utxos', // v3
  snapWalletInventory: 'wallet/snap-inventory',

  healthValidator: 'health/validator',

  transaction: 'transaction',
  feeRates: 'fee-rates',
  localStorage: 'local-storage',
  overviewHistory: 'overview/history',
  overviewMetrics: 'overview/metrics',
  overviewRange: 'overview/range',
  vaultList: 'vault/list',
  liqVaults: 'liq/vaults',
  liqLeaderboard: 'liq/leaderboard',
  telegramNotification: 'telegramNotification',

  // quanta API - queries
  quantaCheck: 'quanta/check',
  quantaLogin: 'quanta/login',
  quantaMissions: 'quanta/missions',
  quantaSideMissions: 'quanta/side-missions',
  quantaMissionTasks: 'quanta/mission-tasks',
  quantaSideMissionTasks: 'quanta/side-mission-tasks',
  quantaRanking: 'quanta/ranking',
  // quanta API - mutations
  quantaRegister: 'quanta/register',
  quantaLevel: 'quanta/level',
  quantaCompleteMissionTask: 'quanta/complete-mission-task',
  quantaCompleteMissionTaskPolling: 'quanta/complete-mission-task-polling',
  quantaReferralCheck: 'quanta/referral-check',
  quantaReferralSet: 'quanta/referral-set',
  quantaVerifyTaskSignature: 'quanta/verify-task-signature',
  // faucet API
  faucetReceiveBtc: 'faucet/receive-btc',
  // liquidation tracking API
  liquidationTracking: 'liquidation/tracking',
  // swap API
  submitTransfer: 'swap/submit-transfer',
  swapPsbt: 'swap/psbt',
  // reserve API
  reserveSummary: 'reserve/summary',
  reserveChart: 'reserve/chart',
  reserveTransactions: 'reserve/transactions',
};
